var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__arrow--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22.923 12.384a1 1 0 00-.217-1.09l-8-8a1 1 0 10-1.414 1.414l6.294 6.294H2a1 1 0 000 2h17.586l-6.293 6.293a1 1 0 101.414 1.414l8-8a1.011 1.011 0 00.216-.325z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }